module.exports = __webpack_public_path__ + "img/luckycatspins.73ed5f60.png";